import { render, staticRenderFns } from "./MantenedorDestinos.vue?vue&type=template&id=21891942&scoped=true&"
import script from "./MantenedorDestinos.vue?vue&type=script&lang=js&"
export * from "./MantenedorDestinos.vue?vue&type=script&lang=js&"
import style0 from "./MantenedorDestinos.vue?vue&type=style&index=0&id=21891942&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21891942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21891942')) {
      api.createRecord('21891942', component.options)
    } else {
      api.reload('21891942', component.options)
    }
    module.hot.accept("./MantenedorDestinos.vue?vue&type=template&id=21891942&scoped=true&", function () {
      api.rerender('21891942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MantenedorDestinos.vue"
export default component.exports